import Cookies from 'js-cookie'
import {cartList} from '@/api/cart'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {setCookie,getCookie} from '@/utils/support';

var ls = window.localStorage;
const app = {
  state: {
    // showList:false,
    user: '',
    status:'',
    name:'',
    company_id:'',
    token: getToken(),
    cartCount:null,
    pdQuery:{
      vin: null,
      keyword: null,
      aikeyword: null,
      number: null,
      numberlist: null,
      rca_model: null,
      customer_id: ls.getItem("partner_id") ? ls.getItem("partner_id") : null,
      page: 1,
      limit: 20
    },
    activeColor:'',
    defaultStatusOptions: [
      {
        label: "草稿",
        value: 0
      },
      {
        label: "已提交",
        value: 1
      },
      {
        label: "已审核",
        value: 2
      },
      {
        label: "已拣货",
        value: 3
      },
      {
        label: "已打包",
        value: 4
      },
      {
        label: "已装车",
        value: 5
      },
      {
        label: "已退货",
        value: 6
      },
      // {
      //   label: "已收货",
      //   value: 7
      // },
      // {
      //   label: "已对账",
      //   value: 8
      // },
      {
        label: "已关闭",
        value: 9
      },
      {
        label: "已驳回",
        value: 10
      },
      {
        label: "删除",
        value: 99
      }
    ],
  },
  mutations: {
    // SHOW_CHECKLIST: state => {
    //   state.showList = !state.showList
    // },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    // SET_USER: (state, user) => {
    //   state.user = user
    // },
    // SET_STATUS: (state, status) => {
    //   state.status = status
    // },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_COMPANYID: (state, company_id) => {
      state.company_id = company_id
    },
    GETCARTCOUNT: (state, cartCount) => {
      state.cartCount = cartCount
    },
    SET_ACTIVECOLOR: (state, activeColor) => {
      state.activeColor = activeColor
    },
    SET_PDQUERY: (state, pdQuery) => {
      state.pdQuery = pdQuery
    },

  },
  actions: {
    // ShowCheckList: ({ commit }) => {
    //   commit('SHOW_CHECKLIST')
    // },
    // getCartCount: ({ commit},cartCount) => {
    //   commit('GETCARTCOUNT',cartCount)
    // },
    async getCartCount ({ commit, state },num) {
      return new Promise(async (resolve, reject) => {
        if (num) {
          commit('GETCARTCOUNT',num)
        } else{
          let res = await cartList()
          if (res.data.status==200) {
            let cartCount = res.data.data.total;
            commit('GETCARTCOUNT',cartCount)
            resolve()
          }
        }
      })
    },
    set_token: ({ commit },token) => {
      commit('SET_TOKEN',token)
    },
    set_name: ({ commit },name) => {
      commit('SET_NAME',name)
    },
    set_companyId: ({ commit },company_id) => {
      commit('SET_COMPANYID',company_id)
    },
    set_activeColor: ({ commit },activeColor) => {
      commit('SET_ACTIVECOLOR',activeColor)
    },
    set_PdQuery: ({ commit },pdQuery) => {
      // console.log(78787,pdQuery)
      commit('SET_PDQUERY',pdQuery)
    },
  }

}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js